import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";

// Icons and Images
import { ReactComponent as AwardIcon } from "images/award-icon.svg";
import { ReactComponent as WorkIcon } from "images/work-icon.svg";
import { ReactComponent as AwardIcon2 } from "images/award-icon2.svg";

import { ReactComponent as CEOIcon } from "images/ceo-icon.svg";

// General styling
const Container = tw.div`relative bg-gray-900 text-white py-20 px-8`; // More padding for breathing space
const ContentWrapper = tw.div`max-w-screen-xl mx-auto flex flex-col lg:flex-row gap-16 lg:gap-32 items-center justify-between lg:py-16`; // Adjusted gap for better spacing

// Left and Right Columns
const LeftColumn = tw.div`w-full lg:w-1/2 flex flex-col items-start`; // Added flex direction
const RightColumn = tw.div`w-full lg:w-1/2 flex flex-col items-start`;

// Subheading, Heading, and Description styles
const Subheading = tw.h4`text-blue-500 text-left mb-4 font-semibold text-lg tracking-wider`; // Slightly larger and more spacing for elegance
const Heading = tw.h1`text-4xl md:text-5xl font-extrabold text-left text-white leading-tight mb-8`; // Increased line height for readability
const Description = tw.p`text-gray-400 text-lg leading-relaxed text-left max-w-xl mb-12`; // Added more relaxed line spacing for improved readability

// Styled list for career and rewards
const ListItem = styled.div`
	${tw`flex items-center mt-6`}
	svg {
		${tw`w-8 h-8 text-blue-500 mr-4 flex-shrink-0`}// Blue accent, flex-shrink to keep icons consistent
	}
	p {
		${tw`text-gray-300 text-lg leading-relaxed`}// Softer gray for better readability
	}
`;

// Enhanced About Component
const AboutComponent = () => {
	const { t } = useTranslation();

	return (
		<Container>
			<ContentWrapper>
				{/* Left Column: Biography */}
				<LeftColumn>
					<Subheading>{t("about.subheading")}</Subheading>
					<Heading>{t("about.heading")}</Heading>
					<Description>{t("about.description")}</Description>

					{/* Career Section */}
					<ListItem>
						<CEOIcon />
						<p>{t("about.career.ceo")}</p>
					</ListItem>
					<ListItem>
						<WorkIcon />
						<p>{t("about.career.raMIA")}</p>
					</ListItem>
					<ListItem>
						<WorkIcon />
						<p>{t("about.career.jsc02")}</p>
					</ListItem>
					<ListItem>
						<WorkIcon />
						<p>{t("about.career.grandCandy")}</p>
					</ListItem>
					<ListItem>
						<WorkIcon />
						<p>{t("about.career.grandSun")}</p>
					</ListItem>
				</LeftColumn>

				{/* Right Column: Rewards */}
				<RightColumn>
					<Subheading>{t("about.rewards.title")}</Subheading>
					{/* Rewards List */}
					<ListItem>
						<AwardIcon />
						<p>{t("about.rewards.reward1")}</p>
					</ListItem>
					<ListItem>
						<AwardIcon2 />
						<p>{t("about.rewards.reward2")}</p>
					</ListItem>
					<ListItem>
						<AwardIcon />
						<p>{t("about.rewards.reward3")}</p>
					</ListItem>
					<ListItem>
						<AwardIcon2 />
						<p>{t("about.rewards.reward4")}</p>
					</ListItem>
					<ListItem>
						<AwardIcon />
						<p>{t("about.rewards.reward5")}</p>
					</ListItem>
				</RightColumn>
			</ContentWrapper>
		</Container>
	);
};

export default AboutComponent;
